<template>
  <el-form class="zj-emergency-login-form" ref="form" :model="form">
    <div class="login-form-title">
      <h3>您好，欢迎登录</h3>
    </div>
    <div class="form-item">
      <el-input
        v-model="form.username"
        maxlength="20"
        placeholder="请输入您的用户名"
        @keyup.enter.native="onEnter"
        autofocus
        clearable
      ></el-input>
    </div>
    <div class="form-item">
      <el-input
        v-model="form.password"
        maxlength="50"
        placeholder="请输入您的密码"
        @keyup.enter.native="onEnter"
        show-password
        clearable
      ></el-input>
    </div>
    <div class="form-item" v-if="mobileEnabled">
      <el-input
        v-model="form.mobile"
        maxlength="11"
        placeholder="请输入您的手机号"
        @keyup.enter.native="onEnter"
        clearable
      ></el-input>
    </div>
    <div class="form-item mobileCaptcha" v-if="mobileEnabled">
      <el-input
        v-model="form.captcha"
        maxlength="6"
        placeholder="请输入验证码"
        @keyup.enter.native="onEnter"
        clearable
      ></el-input>
      <el-button
        class="captcha-button"
        @click="onSendCaptcha"
        title="获取验证码"
        :disabled="!canSendCaptcha"
        >{{ captchaButtonText }}</el-button
      >
    </div>
    <div class="form-item captcha" v-if="captchaEnabled && !this.mobileEnabled">
      <el-input
        v-model="form.vcode"
        :maxlength="captchaLength"
        placeholder="请输入验证码"
        @keyup.enter.native="onEnter"
        clearable
      ></el-input>
      <el-button
        class="captcha-button"
        @click="onRefreshCaptcha"
        title="刷新验证码"
      >
        <el-image :src="captchaUrl">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </el-button>
    </div>
    <div class="form-item">
      <ZJDragVerify
        ref="dragVerify"
        :handler-icon="handlerIcon"
        :success-icon="successIcon"
        @passcallback="changeVerifyState"
      >
      </ZJDragVerify>
    </div>
    <div class="form-item button-bar">
      <el-button
        type="primary"
        class="login-button"
        @click="onSubmit"
        :disabled="!submitEnabled"
        >登 录</el-button
      >
    </div>
  </el-form>
</template>

<script>
import ZJApis from "../api";
import utils from "../utils";
import axios from "axios";
import { login } from "@/api/system/permission/login";

export default {
  name: "ZjEmergencyLoginForm",
  data() {
    return {
      handlerIcon: "el-icon-d-arrow-right",
      successIcon: "el-icon-success",
      isVerifySuccess: false, // 滑块验证成功
      form: {
        username: "",
        password: "",
        vtoken: utils.uuid(),
        vcode: "",
        mobile: "",
        captcha: "",
      },
      captchaTimestamp: new Date().getTime(),
      is_login: false,
      captchaButtonText: "获取验证码",
      canSendCaptcha: true,
      captchaWaitTime: 60,
      mobileEnabled: false,
    };
  },
  computed: {
    submitEnabled() {
      return !this.is_login;
    },
    // 是否启用验证码
    captchaEnabled() {
      return this.CNF("captcha.enabled", false) && this.captchaBaseUrl;
    },
    // 验证码长度，默认 4 字符
    captchaLength() {
      return this.CNF("captcha.length", 4);
    },
    // 验证码的基 URL 地址
    captchaBaseUrl() {
      return this.CNF("captcha.base_url", "");
    },
    // 验证码的 URL 地址: captchaBaseUrl + 时间戳
    captchaUrl() {
      let url = this.captchaBaseUrl;
      url = url
        .replace("{$token}", this.form.vtoken)
        .replace("{$timestamp}", this.captchaTimestamp);
      return url;
    },
  },
  created() {
    this.form.username = this.user.getLastLoginName() || "";
    if (this.CNF("app.isBiaoZhunHua")) {
      this.isMobileValidate();
    }
  },
  destroyed() {
    clearInterval(this.captchaTimer);
    this.canSendCaptcha = true;
    this.captchaButtonText = "获取验证码";
  },
  methods: {
    changeVerifyState() {
      this.isVerifySuccess = true;
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 登录
    login() {
      this.is_login = true;
      let loginInfo = {
        loginName: this.form.username,
        password: this.form.password,
        // vtoken: this.form.vtoken,
        // vcode: this.form.vcode,
      };
      if (!this.form.username) {
        this.is_login = false;
        this.$message({
          showClose: true,
          message: "请输入用户名",
          type: "error",
          customClass: "zj-login-msgbox",
        });
        return;
      }
      if (!this.form.password) {
        this.is_login = false;
        this.$message({
          showClose: true,
          message: "请输入密码",
          type: "error",
          customClass: "zj-login-msgbox",
        });
        return;
      }
      if (this.mobileEnabled && !utils.isRightMobileNum(this.form.mobile)) {
        this.is_login = false;
        this.$message({
          showClose: true,
          message: "请输入正确的手机号",
          type: "error",
          customClass: "zj-login-msgbox",
        });
        return;
      }
      if (this.mobileEnabled && this.form.captcha == "") {
        this.is_login = false;
        this.$message({
          showClose: true,
          message: "请输入正确的验证码",
          type: "error",
          customClass: "zj-login-msgbox",
        });
        return;
      }
      if (this.captchaEnabled && !this.mobileEnabled) {
        // 检查验证码输入框
        if (!this.form.vcode || this.form.vcode.length != this.captchaLength) {
          this.is_login = false;
          this.$message({
            showClose: true,
            message: "请输入正确的验证码",
            type: "error",
            customClass: "zj-login-msgbox",
          });
          return;
        }
        if (!this.isVerifySuccess) {
          this.$message({
            showClose: true,
            message: "请先通过滑动解锁验证",
            type: "error",
            customClass: "zj-login-msgbox",
          });
          this.is_login = false;
          return;
        }
        if (this.mobileEnabled) {
          this.LoginBZHApi(loginInfo);
        } else {
          this.callCheckValiCodeApi(() => {
            //根据配置判断登录权限的获取方式
            if (this.CNF("app.isBiaoZhunHua")) {
              this.LoginBZHApi(loginInfo);
            } else {
              this.callLoginApi(loginInfo);
            }
          });
        }
      } else {
        if (!this.isVerifySuccess) {
          this.$message({
            showClose: true,
            message: "请先通过滑动解锁验证",
            type: "error",
            customClass: "zj-login-msgbox",
          });
          this.is_login = false;
          return;
        }
        if (this.CNF("app.isBiaoZhunHua")) {
          this.LoginBZHApi(loginInfo);
        } else {
          this.callLoginApi(loginInfo);
        }
      }
    },
    // 登录成功
    onLogin(user, loginInfo) {
      this.user.setUser(user, loginInfo.password);
      localStorage.setItem("isIgnoreLogin", false);
      this.$emit("login", user);
      // this.logInfo.ActionName = "登录";
      // this.logInfo.LogMessage = "登录成功";
      // this.logInfo.ModuleName = "登录";
      // this.logInfo.PageName = "登录";
      // this.addOperationLog();
    },
    // 点击回车键
    onEnter() {
      if (this.submitEnabled) {
        this.onSubmit();
      }
    },
    // 点击登录按钮
    onSubmit() {
      this.login();
    },
    // 点击刷新验证码按钮
    onRefreshCaptcha() {
      this.captchaTimestamp = new Date().getTime();
    },
    //标准化登录接口
    LoginBZHApi(loginInfo) {
      let timestamp = new Date().getTime().toString();
      let param = {
        userName: loginInfo.LoginName,
        password: utils.md5utf_8(loginInfo.LoginPwd),
        phone: this.form.mobile,
        code: this.mobileEnabled ? this.form.captcha : loginInfo.vcode,
        perSystemCode: this.CNF("app.perSystemCode"),
        perProjectCode: this.CNF("app.perProjectCode"),
      };
      let url =
        this.CNF("api.apiUrl") + "/permissions-api/permissions/api/per/login";
      const keyV = "ZJHT_API_KEY";
      let sign = utils.md5utf_8(url + keyV + timestamp + param);
      axios({
        method: "post",
        url: url,
        // 传递参数
        data: param,
        // 设置请求头信息
        headers: {
          "Content-Type": "application/json",
          key: "API_KEY",
          ts: timestamp,
          sign: sign,
        },
        responseType: "json",
      })
        .then((response) => {
          // 请求成功
          if (response.data.code === 0) {
            let res = response.data.data;
            let user = {};
            user.UserName = res.user.name || "";
            user.UserId = res.user.code;
            user.LoginName = res.user.userName;
            user.userInfo = res;
            this.onLogin(user, loginInfo);
          } else {
            this.errmsg(
              response.data.msg ? response.data.msg : "服务异常，请联系管理员！"
            );
          }
          this.is_login = false;
        })
        .catch((error) => {
          // 请求失败，
          this.errmsg(error.msg ? error.msg : "服务异常，请联系管理员！");
          this.is_login = false;
          console.log(error);
        });
    },
    //是否需要手机号校验接口
    isMobileValidate() {
      let timestamp = new Date().getTime().toString();
      let param = {
        configKey: "LoginControls",
      };
      let url =
        this.CNF("api.apiUrl") +
        "/permissions-api/permissions/perConfig/findOneByKey";
      const keyV = "ZJHT_API_KEY";
      let sign = utils.md5utf_8(url + keyV + timestamp + param);
      axios({
        method: "post",
        url: url,
        // 传递参数
        data: param,
        // 设置请求头信息
        headers: {
          "Content-Type": "application/json",
          key: "API_KEY",
          ts: timestamp,
          sign: sign,
        },
        responseType: "json",
      })
        .then((response) => {
          // 请求成功
          if (response.data.code === 0) {
            const configValue = JSON.parse(response.data.data.configValue);
            if (
              this.CNF("app.isBiaoZhunHua") &&
              configValue.enable_second_validation != 0
            )
              this.mobileEnabled = true;
          }
        })
        .catch((error) => {
          // 请求失败，
          console.log(error);
        });
    },

    callLoginApi(loginInfo) {
      console.log("loginInfo+++++++++++++===================")
      console.log(loginInfo)
      this.$store
        .dispatch("Login", loginInfo)
        .then((r) => {
          console.log("r+++++++++++++===================")
          console.log(r)
          this.user.setUser(r, loginInfo.password);
          let user = {};
          user.UserName = r.data.user.userName || "";
          user.UserId = r.data.user.userId;
          user.LoginName = r.data.user.userName;
          user.userInfo = r.data.user;
          sessionStorage.setItem("userName", r.data.user.userName)
          this.onLogin(user, loginInfo);
          this.is_login = false;
        })
        .catch(() => {
          this.loading = false;
          this.is_login = false;
        });
    },

    callCheckValiCodeApi(succ) {
      return new ZJApis.CaptchaApi()
        .CheckValiCode({
          vtoken: this.form.vtoken,
          vcode: this.form.vcode,
          vremove: "0", // 不移除验证码记录，因此服务器端可再次验证
        })
        .then((r) => {
          if (r && r.data && r.data.Data && r.data.Data.valid) {
            succ && succ.apply(this, []);
          } else {
            this.errmsg(r && r.RspMsg ? r.RspMsg : "验证码错误，请重新输入！");
            this.is_login = false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.is_login = false;
        });
    },
    // 点击发送验证码按钮
    onSendCaptcha() {
      if (!this.canSendCaptcha) {
        this.$message({
          showClose: true,
          message: "验证码已发送，请过段时间再发",
          type: "error",
          customClass: "zj-login-msgbox",
        });
        return;
      }

      if (!utils.isRightMobileNum(this.form.mobile)) {
        this.$message({
          showClose: true,
          message: "请输入正确的手机号",
          type: "error",
          customClass: "zj-login-msgbox",
        });
        return;
      }

      const that = this;

      this.canSendCaptcha = false;
      this.captchaWaitTime = 60;

      let timestamp = new Date().getTime().toString();
      let param = {
        phone: this.form.mobile, // 必填 手机号
        description: "LOGIN", // 选填 类型，不传默认 LOGIN, 具体类型见 v1.1
        type: "", // 选填 短信签名类型
      };
      let url =
        this.CNF("api.apiUrl") +
        "/permissions-api/permissions/api/per/sendcode";
      const keyV = "ZJHT_API_KEY";
      let sign = utils.md5utf_8(url + keyV + timestamp + param);
      axios({
        method: "post",
        url: url,
        // 传递参数
        data: param,
        // 设置请求头信息
        headers: {
          "Content-Type": "application/json",
          key: "API_KEY",
          ts: timestamp,
          sign: sign,
        },
        responseType: "json",
      })
        .then(() => {
          this.$message({
            message: "验证码已发送到手机号 " + that.form.mobile + "",
            type: "success",
          });
          that.captchaTimer = setInterval(function () {
            if (that.captchaWaitTime == 0) {
              clearInterval(that.captchaTimer);
              that.canSendCaptcha = true;
              that.captchaButtonText = "获取验证码";
            } else {
              that.captchaButtonText = that.captchaWaitTime + "秒后重试";
              that.captchaWaitTime--;
            }
          }, 1000);
        })
        .catch((error) => {
          // 请求失败，
          console.log(error);
          this.$message({
            showClose: true,
            message: "验证码发送失败，请联系管理员",
            type: "error",
            customClass: "zj-login-msgbox",
          });
          this.canSendCaptcha = true;
          this.captchaButtonText = "获取验证码";
        });
    },
  },
};
</script>
